<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin">
                <span class="loader">
                    <span>{{ $spinnerText }}</span>
                </span>
            </div>
        </Transition>

        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <DeptForm :formProps="formProps">
                </DeptForm>
            </template>
            <template #search="searchProps">
                <DeptSearch :searchProps="searchProps">
                </DeptSearch>
            </template>
        </v-view>
    </div>

</template>

<script setup>
import { ref } from "vue";
import DeptForm from './DeptForm.vue'
import DeptSearch from './DeptSearch.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { __, getFromRoute, screenMessage, getTimeouts } from '@pages/Helper/utils.js'

const selectedRows = ref([])

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const isLoading = ref(false)

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
